
import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem, Grid, Typography, Button, /* Paper, */ Card, CardContent, CardActions } from '@material-ui/core';
import { Print, /* CreditCard, Save, AssignmentReturn */ } from "@material-ui/icons";
import { /* fetchCentrosMedicosPropios */ fetchCentrosMedicosPropiosPorUsuario } from "../../actions/centrosMedicosPropios";
import { VisualizadorReportesArqueo } from './VisualizadorReportesArqueo';
import { validarSoloUnPermiso } from '../../helpers/permisos';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { ValidatorForm, SelectValidator } from "react-material-ui-form-validator";
import { ARQUEO_PERMISOS } from "../../utils/permisos";

const useStyles = makeStyles({
    select: {
        '&:before': {
            borderColor: 'white',
        },
        '&:after': {
            borderColor: 'white',
        },
        '&:not(.Mui-disabled):hover::before': {
            borderColor: 'white',
        },
    },
    icon: {
        fill: 'white',
    },
    root: {
        color: 'white',
    },
})


export const ArqueoPorCentroMedico = () => {
    const repo = useRef('');
    const classes = useStyles();
    const dispatch = useDispatch();
    const { items, cargada } = useSelector(state => state.centrosMedicosPropios);
    const [listaCentros, setListaCentros] = useState([]);
    const [cm, setCm] = useState(1);

    const [abrirNuevoReporte, setAbrirNuevoReporte] = useState(false);
    //const [ reporte,  setReporte] = useState('');
    const [fecha, setFecha] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [fechaDesdeNacional, setFechaDesdeNacional] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [fechaHastaNacional, setFechaHastaNacional] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const { permisos: permisosUser } = useSelector(state => state.auth)


    useEffect(() => {
        if (!cargada) {
            // dispatch(fetchCentrosMedicosPropios());
            dispatch(fetchCentrosMedicosPropiosPorUsuario());
        }
        if (items?.length > 0) {
            let convFromState = items.map((centro) => {
                return {
                    value: centro.idCentroMedico,
                    display: centro.descripcionCentro,
                };
            });
            setListaCentros(convFromState);
        }
    }, [items, cargada, dispatch]);
    const handleInputChange = (e) => {
        setCm(e.target.value);
    };
    const handleDateChange = (date) => {
        setFecha(moment(date).format('YYYY-MM-DD'));
    };
    const handleDateChangeHasta = (date) => {
        setFechaHastaNacional(moment(date).format('YYYY-MM-DD'));
    };
    const handleDateChangeNacional = (date) => {
        setFechaDesdeNacional(moment(date).format('YYYY-MM-DD'));
    };

    const handleSubmit = (e) => {
        console.log('sublimt', e);
    }

    const handleClick = (e) => {
        repo.current = 'cm';
        setAbrirNuevoReporte(true);
    }

    const handleClickNacional = (e) => {
        repo.current = 'nacional';
        setAbrirNuevoReporte(true);
    }
    return <>
        <VisualizadorReportesArqueo abrirModal={abrirNuevoReporte} setAbrirModal={setAbrirNuevoReporte} cm={cm} reporte={repo.current} fecha={fecha} fechaDesdeNacional={fechaDesdeNacional} fechaHastaNacional={fechaHastaNacional} />

        <ValidatorForm onSubmit={handleSubmit}>
            <Grid container spacing={3}><Grid item xs={12}>
                <Typography style={{ color: "#FFFFFF" }} component="h4" variant="h4">
                    Arqueo de Coseguros por Centro Médico y Nacional
                </Typography>
            </Grid>
            </Grid>
            <br></br>
            <Grid container
                direction="row"
                justifyContent="space-between"
                alignItems="center" spacing={3}>
                {
                    validarSoloUnPermiso(permisosUser, ARQUEO_PERMISOS.ARQUEO_VER_SOLO_CENTRO_MEDICO) &&
                    <Grid item>
                        <Card elevation={3} sx={{ minWidth: 275 }}>
                            <CardContent>
                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                    Arqueo por Centro Médico
                                </Typography>
                                <Grid container spacing={2}
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center">
                                    <Grid item >
                                        <SelectValidator
                                            className={classes.select}
                                            value={listaCentros?.length > 0 ? cm || '' : ''}
                                            name="id_cm"

                                            onChange={handleInputChange}
                                            label="Centro Medico"
                                            fullWidth={true}
                                            margin="normal"
                                            validators={['required']}
                                            errorMessages={['seleccione una opcion']}
                                        >
                                            <MenuItem value="">
                                                <em>Seleccione</em>
                                            </MenuItem>

                                            {listaCentros.map((cmc) => (
                                                <MenuItem key={cmc.value} value={cmc.value}>
                                                    {cmc.display}
                                                </MenuItem>
                                            ))}
                                        </SelectValidator>

                                    </Grid>
                                    <Grid item >
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="dialogFecha"
                                                label="Fecha"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                maxDate={new Date()} //maxDate
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                value={
                                                    moment(fecha).isValid()
                                                        ? moment(fecha)
                                                        : new Date()
                                                }
                                                onChange={(date) => {
                                                    handleDateChange(date);
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                   
                                </Grid>

                            </CardContent>
                            <CardActions>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={handleClick}
                                    className={classes.button}
                                    startIcon={<Print />}
                                >
                                    IMPRIMIR
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                }
                {
                    validarSoloUnPermiso(permisosUser, ARQUEO_PERMISOS.ARQUEO_VER_TODOS_CM) && <Grid item>
                        <Card elevation={3} sx={{ minWidth: 275 }}>
                            <CardContent>
                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                    Arqueo Nacional
                                </Typography>
                                <Grid container spacing={2}
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center">
                                    <Grid item >
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="dialogFechaNacional"
                                                label="Fecha Desde"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                maxDate={new Date()} //maxDate
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                value={
                                                    moment(fechaDesdeNacional).isValid()
                                                        ? moment(fechaDesdeNacional)
                                                        : new Date()
                                                }
                                                onChange={(date) => {
                                                    handleDateChangeNacional(date);
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item >
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="dialogFechaHasta"
                                                label="Fecha Hasta"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                maxDate={new Date()} //maxDate
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                value={
                                                    moment(fechaHastaNacional).isValid()
                                                        ? moment(fechaHastaNacional)
                                                        : new Date()
                                                }
                                                onChange={(date) => {
                                                    handleDateChangeHasta(date);
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>

                            </CardContent>
                            <CardActions>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={handleClickNacional}
                                    className={classes.button}
                                    startIcon={<Print />}
                                >
                                    IMPRIMIR
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                }
            </Grid>
        </ValidatorForm>
    </>;
};
